module.exports = __webpack_public_path__ + "static/media/renew-feed.3a8e9112.svg";